export default "__VITE_ASSET__D851rBAm__"